import { useState } from 'react';
import type { MediaRef } from '@ezishizi/content-schema';

/**
 * A word's picture filling its box, for stickers and the cinema. Tries the thumbnail first and
 * falls back to the full image, then to the hanzi, so a card is never an empty square. `dim`
 * paints it as a flat silhouette (a sticker not earned yet).
 */
export function StickerArt({
  media,
  char,
  dim = false,
  className = '',
}: {
  media: MediaRef;
  /** Shown if the picture cannot load at all. */
  char: string;
  dim?: boolean;
  className?: string;
}) {
  const [src, setSrc] = useState<string | null>(
    media.kind === 'url' ? media.url.replace(/\.webp$/i, '.thumb.webp') : null,
  );
  const [failed, setFailed] = useState(false);
  const filter = dim ? 'brightness(0) opacity(0.14)' : undefined;
  if (media.kind === 'emoji' || failed || media.kind !== 'url')
    return (
      <span
        className={`flex h-full w-full items-center justify-center leading-none select-none ${className}`}
        style={{ filter, fontSize: '3.5rem' }}
        role="img"
        aria-hidden
      >
        {media.kind === 'emoji' ? media.value : <span className="hanzi">{char}</span>}
      </span>
    );
  return (
    <img
      src={src ?? media.url}
      alt=""
      draggable={false}
      className={`h-full w-full object-contain select-none ${className}`}
      style={{ filter }}
      onError={() => {
        if (src !== media.url) setSrc(media.url);
        else setFailed(true);
      }}
    />
  );
}
